import { getColumnIndexFromDate } from "./getColumnIndexFromDate";

/**
 * Used to format the data of the user management type report,
 * group by user and calculated the total sum per row
 */
export function formatUserManagementData({ rawData = [], valueType = "tmo" } = {}) {
  const formattedData = [];

  rawData.forEach((item) => {
    const rowObject = {
      usuario: item.usuario,
      total: 0,
    };

    item.data.forEach((itemData) => {
      const rowIndexKey = getColumnIndexFromDate({ date: itemData.fecha });

      rowObject[rowIndexKey] = itemData.values[valueType];
      rowObject.total += itemData.values[valueType];
    });

    formattedData.push(rowObject);
  });

  return formattedData;
}
